<div style="margin: 10px; height: calc(100vh - 100px - 40px);">

    <!-- New discovery button/dialog -->
    <button type="button" (click)="displayNewDiscoveryDialog=true" pButton icon="fa fa-plus-square-o" label="Add Discovery" class="add-button"></button>

    <new-discovery-dialog [display]="displayNewDiscoveryDialog" [parent]="agent"
                          (onClose)="onNewDiscoveryDialogClose()">
    </new-discovery-dialog>

    <!-- Search Box-->
    <div style="padding:4px 10px;border-bottom: 0 none">
        <i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
        <input type="text" pInputText size="50" placeholder="Filter" (input)="tt.filterGlobal($event.target.value, 'contains')">

    </div>

    <!-- Data table -->
    <p-table #tt [value]="discoveries" [globalFilterFields]="['Name']" rowHover="false"
             [scrollable]="true"  [resizableColumns]="true" scrollHeight="calc(100vh - 180px - 20px)">

        <ng-template pTemplate="header">
            <tr>
                <th pResizableColumn>Name</th>
                <th pResizableColumn>Created</th>
                <th pResizableColumn>Modified</th>
                <th pResizableColumn>Schedule</th>
                <th pResizableColumn >Enabled</th>
                <th pResizableColumn class="uv-table-button-column-2"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr class="discovery" >
                <td (click)="onDiscoveryClick(rowData)">
                    <span class="uv-table-value">{{ rowData.Name }}</span>
                </td>
                <td (click)="onDiscoveryClick(rowData)">
                    <span class="uv-table-value">{{ formatDateHm(rowData.CreatedTime) }}</span>
                </td>
                <td (click)="onDiscoveryClick(rowData)">
                    <span class="uv-table-value">{{ formatDateHm(rowData.ModifiedTime) }}</span>
                </td>
                <td (click)="onDiscoveryClick(rowData)">
                    <span class="uv-table-value">{{ rowData.Schedule.Summary }}</span>
                </td>
                <td class="uv-table-enable-checkbox">
                    <p-checkbox binary="true" [ngModel]="rowData.Enabled" 
                                (click)="toggleDiscoveryEnableState(rowData)"></p-checkbox>
                </td>
                <td class="uv-table-button-column-2">
                    <button type="button" class="btn btn-primary uv-first-table-button" (click)="runAsap(rowData)"
                            title="Run this discovery ASAP">
                        <i class="fa fa-caret-square-o-right"></i>
                    </button>
                    <button type="button" class="btn btn-danger uv-table-button" title="Delete this discovery"
                            (click)="tryDeleteDiscovery($event, rowData.GUID)">
                        <i class="pi pi-trash"></i>
                    </button>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>


<confirmation-dialog message="Are you sure you want to delete this discovery?"
                     [display]="displayDeleteDiscoveryConfirm"
                     (onYes)="deleteDiscovery()" (onNo)="cancelDeleteDiscovery()">
</confirmation-dialog>
